const layoutStyles = {
	/**
	 * Header tem 64px de altura (display:none < 1280px, display:flex >= 1280px).
	 * Classes literais para o scanner do Tailwind enxergar.
	 */
	content:
		'flex min-h-[calc(100dvh-64px)] w-full flex-col bg-neutral-high-light text-neutral-low-dark antialiased'
} as const;

export { layoutStyles };
